import { handleAxiosError } from '@/api/common/handleAxiosError';
import { jwtVerify, createRemoteJWKSet } from 'jose';

export async function validateToken(token: string) {
  try {
    if (!token) return false;

    const JWKS_URI = import.meta.env.VITE_JWKS_URI;
    if (!JWKS_URI) {
      return false;
    }

    const JWKS = createRemoteJWKSet(new URL(JWKS_URI));

    const { payload } = await jwtVerify(token, JWKS, {
      algorithms: ["RS256"],
      clockTolerance: 60, // 60 seconds of tolerance for clock skew
    });
    return payload;
  } catch (error) {
    handleAxiosError(error, "Error al validar el token");
    return false;
  }
}
